module.exports = __webpack_public_path__ + "static/media/amit.ff5e61f1.png";